import { Box, Heading, Image, SimpleGrid, Stack } from "@chakra-ui/react"
import { InView } from "react-intersection-observer"
import React, { useState } from "react"

export const AnimatedScrollSection = ({ data }) => {
    const [visibleIndex, setVisibleIndex] = useState(0)
    return (
        <Stack
            spacing={{ base: 20, md: 28 }}
            justify="space-between"
            py={{ base: 20, md: 0 }}
        >
            <SimpleGrid
                columns={{ base: 1, md: 2 }} gap={{ base: '6', md: '24' }}
                gridTemplateColumns={{ base: "1fr", md: "1.3fr 1fr" }}
                display={{ base: 'initial', md: 'grid' }}
            >
                {data?.map((item, i) => {
                    const lastItem = i === data?.length - 1
                    return (
                        <React.Fragment key={`${item?.key}-${i}`}>
                            <ImageSide item={item} i={i} visibleIndex={visibleIndex} />
                            <TextSide item={item} lastItem={lastItem} i={i} visibleIndex={visibleIndex} setVisibleIndex={setVisibleIndex} />
                        </React.Fragment>
                    )
                })}
            </SimpleGrid>
        </Stack>
    )
}

const ImageSide = ({ item, i, visibleIndex }) => {
    return (
        <Box
            minH={{ base: 'initial', md: "75vh" }}
            display={{ base: 'intial', md: 'grid' }}
            placeItems="center"
            position={{ base: 'intial', md: 'sticky' }}
            top={{ base: 'initial', md: '10vh' }}
            gridColumn={1}
            gridRow={1}
            transition="all 300ms linear"
            opacity={{ base: 1, md: visibleIndex === i ? 1 : 0 }}
        >
            <Image
                as={Image}
                borderRadius="md"
                maxH={{ base: 'initial', md: "75vh" }}
                src={item?.imgSrc}
                alt={item?.label}
                border="1px solid"
                borderColor="gray.200"
            />
        </Box>
    )
}

const TextSide = ({ item, i, lastItem, visibleIndex, setVisibleIndex }) => {
    return (
        <InView threshold={1} onChange={(visible) => {
            if (visible) setVisibleIndex(i)
        }}>
            {({ inView, ref }) => (
                <Box
                    ref={ref}
                    spacing={{ base: '4', md: '6' }}
                    maxW={{ base: "full", md: "sm" }}
                    my="auto"
                    mb={{ base: 'initial', md: lastItem ? '10vh' : 'auto' }}
                    h={{ base: 'auto', md: "50vh" }}
                    gridColumn={2}
                    justifyContent="start"
                    display="grid"
                    placeItems="center"
                    transition="all 600ms linear"
                    opacity={{ base: 1, md: visibleIndex === i ? 1 : 0 }}
                    pt={{ base: 6, md: 'initial' }}
                    pb={{ base: 12, md: 'initial' }}
                >
                    <Stack spacing={{ base: '4', md: '6' }}>
                        <Heading
                            align="start"
                            size={{ base: 'xs', md: 'sm' }}
                            color="fg.default"
                        >
                            {item?.label}
                        </Heading>
                        <Box
                            align="start"
                            fontSize={{ base: 'md', md: 'lg' }}
                            color="fg.muted"
                        >
                            {item?.description}
                        </Box>
                    </Stack>
                </Box>)}
        </InView>
    )
}